/* tslint:disable:max-line-length component-class-suffix */

import { Component, OnInit, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DDMenuEnableDisableService } from '../../../shared/service/common/dd-menu-enable-disable.service';
import {
  MenuActionSetActive
} from '../../../store/actions/menu.action';
import {
  SetSharedDataAction
} from '../../../store/actions/shared-data.action';
//
// Library Code
//
import * as Library from '../../../../lib/core/library/index';
import { Action } from '../../../../lib/core/common/action';
import { Vehicle } from '../../../../lib/angular/model/vehicle/vehicle';
//
// Cards
//
import { LocalSpecialCard } from '../../../../lib/angular/model/card/local-special-card';
import { RtiCashCard } from '../../../../lib/angular/component/common/rti-cash-card/rti-cash-card';
//
// Store
//
import { Store } from '@ngrx/store';
import {
  IAppState,
  SharedDataStore,
  LocalSpecialStore
} from '../../../store/index';

@Component({
  selector: 'dd-v-spec-local-special',
  templateUrl: './v-spec-local-special.html',
  styleUrls: ['./v-spec-local-special.scss']
})
export class VSpecLocalSpecial implements OnInit, OnDestroy {
  //
  // Public
  //
  public vehicle: Vehicle;
  public shared: any;
  public cards: LocalSpecialCard[];
  public handleCardEvent: any;
  public card: LocalSpecialCard;
  public dialogActions: Action[];
  //
  // Private
  //

  //
  // OnInit
  //
  public ngOnInit() {
    //
    // Get access to the parent data
    //
    this._route.parent.data.subscribe((params: any) => {
      //
      // Get Vehicle Information
      //
      this.vehicle = params['data'];

      //
      // Get Access to Shared Data
      //
      this._store.select(SharedDataStore).subscribe(data => {
        this.shared = Object.assign({}, data, {
          vehicleDetails: this.vehicle,
          currentVin: this.vehicle.vin
        });
      });

      //
      // Save Shared Data
      //
      this._store.dispatch(new SetSharedDataAction(this.shared));

      this._ddMenuEnableDisableService.loadFeatureConfigData(this.vehicle);
      this._ddMenuEnableDisableService.loadProtectionProducts(this.shared);
      this._store.dispatch(new MenuActionSetActive(<any>{label: 'Local Special'}));

      //
      // Get Local Special Data
      //
      this._store.select(LocalSpecialStore).subscribe(data => {
        // ::SDL
        // Here's where we need to apply the offers and use the business rules
        // as defined within the

        // this.cards = data.items[0].offerBundle.offers.map((special) =>
        //   new LocalSpecialCard({
        //     title: special.getTitle(),
        //     label: special.getLabel(),
        //     type: special.getOfferType(),
        //     duration: 36,
        //     durationTerm: 'months',
        //     downpayment: 1999,
        //     downpaymentCondition: 'due at signing',
        //     monthlypayment: 209,
        //     term: 'per month',
        //     price: 20000,
        //     image: {
        //       style: {
        //         height: '181px',
        //         width: '350px'
        //       },
        //       alt: special.offerCard.title,
        //       href: special.offerCard.image
        //     },
        //     style: {
        //       height: '510px',
        //       width: '378px'
        //     },
        //     onClick: this._onClickSpecial.bind(this)
        //   })
        // );
      });
    });

    //
    // Populate Cards with data here....
    //
    this.cards = [
      new LocalSpecialCard({
        type: RtiCashCard,
        title: 'Cash Back',
        label: '2018 Rav 4',
        duration: 36,
        durationTerm: 'months',
        downpayment: 1999,
        downpaymentCondition: 'due at signing',
        monthlypayment: 209,
        term: 'per month',
        price: 20000,
        image: {
          style: {
            height: '181px',
            width: '350px'
          },
          href:
            'https://media.rti.dev.toyota.com/config/pub/3d/toyota/1005649/1000859/Exterior/1/864_477_PNG/d462237-d21c548-e1c7e41-f2ac6ee-0f3fa98-f51046f-522f215-3ff60b8-b04f3b5-0879ac4.png'
        },
        style: {
          width: '378px'
        },
        onClick: this._onClickSpecial.bind(this)
      }),
      new LocalSpecialCard({
        type: RtiCashCard,
        title: 'Lease Special',
        label: '2018 Rav 4',
        duration: 36,
        durationTerm: 'months',
        downpayment: 1999,
        downpaymentCondition: 'due at signing',
        monthlypayment: 209,
        term: 'per month',
        price: 20000,
        image: {
          style: {
            height: '181px',
            width: '250px'
          },
          href:
            'https://media.rti.dev.toyota.com/config/pub/static/images/TOY/2018/priusc/exteriorcolor/carjellyimage/74c935eb0975f79474dc6dfd3c4478f1d3bfbb7c5ee8c3c6aaf7290a07ab7b18_MY18_265B_US_THREE_0082_002.png'
        },
        style: {
          width: '378px'
        },
        onClick: this._onClickSpecial.bind(this)
      }),
      new LocalSpecialCard({
        type: RtiCashCard,
        title: 'Cash Back',
        label: '2018 Rav 4',
        duration: 36,
        durationTerm: 'months',
        downpayment: 1999,
        downpaymentCondition: 'due at signing',
        monthlypayment: 209,
        term: 'per month',
        price: 20000,
        image: {
          style: {
            height: '181px',
            width: '250px'
          },
          href:
            'https://media.rti.dev.toyota.com/config/pub/static/images/TOY/2019/chr/exteriorcolor/carjellyimage/ff3bb1a1a0914ea934b6aa9774d14646a6e2afe3cfb8bd594f7f4c5b71de7d9e_MY19_C-HR_US_LE_0209_002.png'
        },
        style: {
          width: '378px'
        },
        onClick: this._onClickSpecial.bind(this)
      })
    ];
  }

  //
  // ngOnDestroy
  //
  ngOnDestroy() {}

  //
  // _onClickSpecial()
  //
  private _onClickSpecial(obj: any) {
    const uid = obj.uid;
    this.card = this.cards.find(card => card.uid === uid);
    if (Library.isDefined(this.handleCardEvent)) {
      this.handleCardEvent.onClick.emit(obj);
    }
  }

  //
  // Constructor
  //
  constructor(
    private _store: Store<IAppState>,
    private _route: ActivatedRoute,
    private _ddMenuEnableDisableService: DDMenuEnableDisableService,
  ) {
    this.vehicle = new Vehicle();
    this.handleCardEvent = {
      onClick: new EventEmitter<any>(),
      hidden: false
    };
    this.dialogActions = [
      new Action({
        name: 'View Detail',
        onClick: $event => {}
      })
    ];
    this.card = new LocalSpecialCard();
    this.cards = [];
  }
}
